import { FC, useState, useEffect, useMemo } from 'react';
import { Box, makeStyles, Theme, Typography, Card, CardContent, Grid, Avatar, List, ListItem, ListItemAvatar, ListItemText, Divider } from '@material-ui/core';
import FeaturedAlbum from 'components/FeaturedAlbum';
import FeaturedArtist from 'components/FeaturedArtist';
import StarsIcon from '@material-ui/icons/Stars';
import TopSongOfTheWeek from "../components/TopSongOfTheWeek"
import FlaggedContent from 'containers/FlaggedContent';
import {
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  PersonAdd as PersonAddIcon,
  TrendingUp as TrendingUpIcon,
  SupervisorAccount as SuperAdminIcon,
  CheckCircle as CheckCircleIcon
} from '@material-ui/icons';
import AddedAlbumByWeek from 'components/AddedAlbumsByWeek';
import AddedAlbumByMonth from 'components/AddedAlbumByMonth';
import TopArtistAlbumByWeek from 'components/TopArtistAlbumByWeek';
import TopArtistAlbumByMonth from 'components/TopArtistAlbumByMonth';
import RegisteredUserWeek from "components/RegisteredUserWeek";
import { useQuery, useMutation } from '@apollo/client';
import userSignUp, {
  userSignupResponse
} from "../core/graphql/queries/findUserSignup"
import artistSignUp, {
  artistSignUpResponse
} from "../core/graphql/queries/findArtistSignup"
import findRevenue, {
  findRevenueResponse
} from "../core/graphql/queries/findRevenue"
import { GET_ANALYTICS_DATA, GetAnalyticsDataResponse } from "../core/graphql/queries/analytics"
import { ALL_AFFILIATES, AllAffiliatesQueryResponse } from "../core/graphql/queries/affiliate"
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TopAlbums } from "../components/Top5Album"
import { TopArtist } from "../components/Top5Artist"
import ListContainer from "../components/@ui/ListContainer"
import { TopSong } from "../components/TopSong"
import { formatDistanceToNow } from 'date-fns';
// import  BellIcon  from "../pictures/belly.svg"

const useStyle = makeStyles<Theme>((theme) => ({
  button: {
    '&:hover': {
      cursor: 'pointer',
    },
    marginRight: '20px',
  },
  title1: { color: 'white', fontWeight: 'bold' },
  inactiveSelector: { color: '#455A6D', fontWeight: 'bold' },
  activeSelector: { color: '#3D7670', fontWeight: 'bold' },
  underline: {
    borderBottom: "2px solid #0ED3BF",
    paddingBottom: "1px"
  },
  chartHead: {
    fontSize: '20px',
    paddingLeft: '20px'
  },
  statsCard: {
    backgroundColor: '#1a2332',
    border: '1px solid #2a3a4a',
    borderRadius: 12,
    transition: 'all 0.2s ease-in-out',
    height: '100%',
  },
  statsCardContent: {
    padding: theme.spacing(3),
  },
  statsIcon: {
    width: 48,
    height: 48,
    marginBottom: theme.spacing(2),
  },
  statsNumber: {
    color: '#fff',
    fontWeight: 700,
    fontSize: '2.25rem',
    lineHeight: 1,
    marginBottom: theme.spacing(0.5),
  },
  statsLabel: {
    color: '#b0b0b0',
    fontSize: '0.9rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  activityCard: {
    backgroundColor: '#1a2332',
    border: '1px solid #2a3a4a',
    borderRadius: 12,
    padding: theme.spacing(3),
  },
  activityTitle: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.25rem',
    marginBottom: theme.spacing(3),
  },
  activityItem: {
    padding: theme.spacing(2, 0),
    color: '#fff',
  },
  activityText: {
    color: '#fff',
    fontWeight: 500,
    fontSize: '0.95rem',
  },
  activityTime: {
    color: '#b0b0b0',
    fontSize: '0.85rem',
  },
  divider: {
    backgroundColor: '#2a3a4a',
  },
}));

const Dashboard: FC = (props) => {
  const [tabs, setTabs] = useState('album')
  // Default to "today" for all date ranges
  const [type, setType] = useState("today")
  const [typeRevenue, setTypeRevenue] = useState("today")
  const [typeRevenueExact, setTypeRevenueExact] = useState("today")
  const [typeuser, setTypeUser] = useState("today")
  const [typeartist, setTypeArtist] = useState("today")
  const [exactType, setExactType] = useState("today")
  const [exactTypeArt, setExactTypeArt] = useState("today")

  // Map dropdown selection to type parameter (matching AdminDashboard approach)
  const queryType = useMemo(() => {
    switch (type) {
      case 'today': return 'today';
      case 'week': return 'week';
      case 'month': return 'month';
      case 'year': return 'year';
      case 'allTime': return 'allTime';
      default: return 'today'; // Default to today if not set
    }
  }, [type]);

  // Map dropdown values to type values for chart queries (revenue, user signup, artist signup)
  // These queries use "type" parameter - backend may only support: "week", "month", "year", "allTime"
  // Note: "today" and year strings may not be supported yet - backend may need updates
  const getChartType = (range: string): string => {
    if (range === 'allTime') return 'allTime';
    if (range === 'week' || range === '7d') return 'week';
    if (range === 'month' || range === '30d') return 'month';
    if (range === 'year' || range === '1y') return 'year';
    // For "today" and year strings, try passing through - backend may need to support these
    // If backend doesn't support, it will return an error which we'll display
    return range;
  };

  // Analytics data query - now uses type parameter (matching AdminDashboard approach)
  const effectiveType = queryType || 'today';
  console.log('🔵 Analytics query - type:', type, '-> queryType:', queryType, '-> effectiveType:', effectiveType);
  
  const { data: analyticsData, loading: analyticsLoading, error: analyticsError } = useQuery<GetAnalyticsDataResponse>(GET_ANALYTICS_DATA, {
    variables: { type: effectiveType },
    errorPolicy: 'all',
    fetchPolicy: 'network-only', // Force network request, don't use cache
    notifyOnNetworkStatusChange: true
  });

  // Log analytics data for debugging
  useEffect(() => {
    console.log('🔵 Dashboard - type:', type, '-> queryType:', queryType, '-> effectiveType:', effectiveType);
    console.log('🔵 Dashboard - Variables being sent:', { type: effectiveType });
    if (analyticsData) {
      console.log('🔵 Dashboard analyticsData:', analyticsData);
      console.log('🔵 Dashboard analytics values for', type, ':', {
        totalPlays: analyticsData?.analyticsData?.totalPlays,
        totalEarnings: analyticsData?.analyticsData?.totalEarnings,
        totalArtists: analyticsData?.analyticsData?.totalArtists,
        type: effectiveType
      });
    }
    if (analyticsError) {
      console.error('🔵 Dashboard analyticsError:', analyticsError);
      console.error('🔵 Analytics error details:', {
        message: analyticsError.message,
        graphQLErrors: analyticsError.graphQLErrors,
        networkError: analyticsError.networkError
      });
    }
  }, [analyticsData, analyticsError, type, queryType, effectiveType]);

  // Pending affiliates query
  const { data: affiliatesData, loading: affiliatesLoading, error: affiliatesError } = useQuery<AllAffiliatesQueryResponse>(ALL_AFFILIATES, {
    variables: { status: 'pending', limit: 1000 },
    errorPolicy: 'all'
  });

  // Log affiliates data for debugging
  useEffect(() => {
    if (affiliatesData) {
      console.log('Dashboard affiliatesData:', affiliatesData);
    }
    if (affiliatesError) {
      console.error('Dashboard affiliatesError:', affiliatesError);
    }
  }, [affiliatesData, affiliatesError]);

  const QueryMultiple = () => {
    const res1 = useQuery<userSignupResponse>(userSignUp, {
      variables: {
        type: getChartType(exactType)
      },
      errorPolicy: 'all'
    });
    const res2 = useQuery<artistSignUpResponse>(artistSignUp, {
      variables: {
        type: getChartType(exactTypeArt)
      },
      errorPolicy: 'all'
    })
    const res5 = useQuery<findRevenueResponse>(findRevenue, {
      variables: {
        type: getChartType(typeRevenueExact)
      },
      errorPolicy: 'all'
    });
    return [res1, res2, res5];
  }

  const [
    { loading: loading1, data: data1, error: error1 },
    { loading: loading2, data: data2, error: error2 },
    { loading: loading5, data: data5, error: error5 },
  ] = QueryMultiple()

  // Log revenue data for debugging
  useEffect(() => {
    if (data5) {
      console.log('Dashboard revenue data5:', data5);
    }
    if (error5) {
      console.error('Dashboard revenue error5:', error5);
      console.error('Revenue error details:', {
        message: error5.message,
        graphQLErrors: error5.graphQLErrors,
        networkError: error5.networkError,
        extraInfo: error5.extraInfo
      });
    }
  }, [data5, error5]);

  // Log signup data for debugging
  useEffect(() => {
    if (data1) {
      console.log('Dashboard streamer signup data1:', data1);
      console.log('Streamer signup data array:', data1?.findUsers?.data);
      console.log('Streamer signup count for', exactType, ':', 
        data1?.findUsers?.data?.reduce((sum: number, count: number) => sum + (count || 0), 0) || 0);
    }
    if (error1) {
      console.error('Dashboard streamer signup error1:', error1);
      console.error('Streamer error details:', {
        message: error1.message,
        graphQLErrors: error1.graphQLErrors,
        networkError: error1.networkError
      });
    }
    if (data2) {
      console.log('Dashboard artist signup data2:', data2);
      console.log('Artist signup data array:', data2?.findAritst?.data);
      console.log('Artist signup count for', exactTypeArt, ':', 
        data2?.findAritst?.data?.reduce((sum: number, count: number) => sum + (count || 0), 0) || 0);
    }
    if (error2) {
      console.error('Dashboard artist signup error2:', error2);
      console.error('Artist error details:', {
        message: error2.message,
        graphQLErrors: error2.graphQLErrors,
        networkError: error2.networkError
      });
    }
  }, [data1, error1, data2, error2, exactType, exactTypeArt]);

  // Calculate pending affiliates count
  const pendingAffiliatesCount = affiliatesData?.allAffiliates?.filter((aff: any) => aff.status === 'pending' || aff.status === 'PENDING').length || 0;


  const handleChange = (event: SelectChangeEvent) => {
    const newValue = event.target.value;
    console.log('🔵 handleChange called with value:', newValue);
    setTypeUser(newValue);
    setTypeArtist(newValue);
    setType(newValue);
    setExactType(newValue);
    setExactTypeArt(newValue);
    setTypeRevenue(newValue);
    setTypeRevenueExact(newValue);
    console.log('🔵 State updated, type should now be:', newValue);
  };

  const handleChangeUser = (event: SelectChangeEvent) => {
    setTypeUser(event.target.value);
    setExactType(event.target.value)

  };

  const handleChangeArtist = (event: SelectChangeEvent) => {
    setTypeArtist(event.target.value);
    setExactTypeArt(event.target.value)

  };

  const handleRevenueChange = (event: SelectChangeEvent) => {
    setTypeRevenue(event.target.value)
    setTypeRevenueExact(event.target.value)

  };

  // const handleNotification = ()=>{
  //   history.push("/notifications")
  // }



  const classes = useStyle();

  const streamer = data1?.findUsers?.dates?.map((id: any, index: any) => {
    return {
      label: data1?.findUsers?.dates[index] || '',
      UserSignup: data1?.findUsers?.data?.[index] || 0
    }
  }) || [];

  const artist = data2?.findAritst?.dates?.map((id: any, index: any) => {
    return {
      label: data2?.findAritst?.dates[index] || '',
      ArtistSignup: data2?.findAritst?.data?.[index] || 0
    }
  }) || []

  // Calculate new artists count for the selected period
  // For "All Time", use totalArtists from analytics
  // For other periods, sum up the artist signup data array
  const newArtistsCount = type === 'allTime' 
    ? (analyticsData?.analyticsData?.totalArtists || 0)
    : (data2?.findAritst?.data && Array.isArray(data2.findAritst.data) && data2.findAritst.data.length > 0
        ? data2.findAritst.data.reduce((sum: number, count: number) => sum + (count || 0), 0)
        : 0);

  const revenue = data5?.revenueDayWeekMonthYear?.date?.map((id: any, index: any) => {
    return {
      label: data5?.revenueDayWeekMonthYear?.date[index] || '',
      TotalRevenue: data5?.revenueDayWeekMonthYear?.data?.[index] || 0
    }
  }) || []

  const getActivityIcon = (activityType: string) => {
    switch (activityType) {
      case 'ARTIST_REGISTERED':
        return { Icon: SuperAdminIcon, color: '#e91e63' };
      case 'AFFILIATE_APPLICATION':
        return { Icon: PersonAddIcon, color: '#1976d2' };
      case 'PAYOUT_PROCESSED':
        return { Icon: CheckCircleIcon, color: '#4caf50' };
      case 'PLAY':
        return { Icon: TrendingUpIcon, color: '#ff9800' };
      default:
        return { Icon: PeopleIcon, color: '#607d8b' };
    }
  };

  const formatActivityTime = (timeString?: string) => {
    if (!timeString) return 'Unknown time';
    const parsed = new Date(timeString);
    if (Number.isNaN(parsed.getTime())) return timeString;
    return formatDistanceToNow(parsed, { addSuffix: true });
  };

  const recentActivityItems = (analyticsData?.analyticsData?.recentActivity || []).slice(0, 6);

  const playsByDate = recentActivityItems
    .filter((activity: any) => activity?.type === 'PLAY' && activity?.time)
    .reduce((acc: Record<string, number>, activity: any) => {
      const parsed = new Date(activity.time);
      if (Number.isNaN(parsed.getTime())) {
        return acc;
      }
      const dateKey = parsed.toISOString().split('T')[0];
      acc[dateKey] = (acc[dateKey] || 0) + 1;
      return acc;
    }, {});

  const playsRevenueTrend = revenue.map((point: any) => ({
    label: point.label,
    TotalRevenue: Number(point.TotalRevenue) || 0,
    Plays: playsByDate[point.label] || 0
  }));

  // Log revenue array for debugging
  useEffect(() => {
    console.log('Dashboard revenue array:', revenue);
    console.log('Dashboard revenue data5 structure:', {
      hasData: !!data5,
      hasRevenue: !!data5?.revenueDayWeekMonthYear,
      hasDate: !!data5?.revenueDayWeekMonthYear?.date,
      hasDataArray: !!data5?.revenueDayWeekMonthYear?.data,
      dateLength: data5?.revenueDayWeekMonthYear?.date?.length,
      dataLength: data5?.revenueDayWeekMonthYear?.data?.length
    });
  }, [revenue, data5]);

  let comp
  if (tabs === 'album') {
    comp = <TopAlbums type={type} />
  }
  else if (tabs === 'song') {
    comp = <TopSong type={type} />
  }
  else {
    comp = <TopArtist type={type} />
  }



  const isAuthError = (e: any) =>
    e?.message && (String(e.message).includes('Unauthorized') || String(e.message).includes('admin account'));
  const showSignInHint = isAuthError(error5) || isAuthError(error1) || isAuthError(error2);

  return (
    <>
      <Box display="flex" flexDirection="column" padding="20px 50px" marginBottom="20px">
        {showSignInHint && (
          <Box mb={2} p={1.5} bgcolor="#1a2332" borderRadius={1} border="1px solid #2a3a4a">
            <Typography style={{ color: '#b0b0b0', fontSize: '0.9rem' }}>
              You're viewing without signing in. Numbers may be zero and some sections are hidden. Sign in at{' '}
              <a href="/login" style={{ color: '#3D7670' }}>/login</a> to see full dashboard data.
            </Typography>
          </Box>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{display:'flex', alignItems: 'center' }}>
            <p style={{ margin: '0 2px 3px', fontSize: '14px', color: "#3D7670" }}>
              Display data for
            </p>
            <FormControl variant="standard" sx={{ m: 1, width: 120 }} style={{ fontSize: '12px' }}>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={type}
                onChange={handleChange}
                label="Age"
              >
                <MenuItem value={"today"}>Today</MenuItem>
                <MenuItem value={"week"}>Past 7 Days</MenuItem>
                <MenuItem value={"month"}>Past Month</MenuItem>
                <MenuItem value={"year"}>This Year</MenuItem>
                <MenuItem value={"allTime"}>All Time</MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* <div style={{cursor:'pointer'}} onClick={handleNotification}>
            <img src={BellIcon} />
          </div> */}

        </div>

        <div style={{ marginTop: "15px" }}>
          <h2 style={{ fontSize: '22px' }}>
            Quick Overview
          </h2>
        </div>

        {/* Stats Cards */}
        <Grid container spacing={3} style={{ marginTop: '20px', marginBottom: '20px' }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent className={classes.statsCardContent}>
                <Avatar 
                  className={classes.statsIcon} 
                  style={{ backgroundColor: '#e91e63' }}
                >
                  <SuperAdminIcon />
                </Avatar>
                <Typography className={classes.statsNumber}>
                  {(analyticsLoading || loading2) ? '...' : newArtistsCount.toLocaleString()}
                </Typography>
                <Typography className={classes.statsLabel}>
                  Artists
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent className={classes.statsCardContent}>
                <Avatar 
                  className={classes.statsIcon} 
                  style={{ backgroundColor: '#1976d2' }}
                >
                  <PersonAddIcon />
                </Avatar>
                <Typography className={classes.statsNumber}>
                  {affiliatesLoading ? '...' : pendingAffiliatesCount.toLocaleString()}
                </Typography>
                <Typography className={classes.statsLabel}>
                  Pending Affiliates
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent className={classes.statsCardContent}>
                <Avatar 
                  className={classes.statsIcon} 
                  style={{ backgroundColor: '#4caf50' }}
                >
                  <MoneyIcon />
                </Avatar>
                <Typography className={classes.statsNumber}>
                  {analyticsLoading ? '...' : `$${(analyticsData?.analyticsData?.totalEarnings || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                </Typography>
                <Typography className={classes.statsLabel}>
                  Total Earnings
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card className={classes.statsCard}>
              <CardContent className={classes.statsCardContent}>
                <Avatar 
                  className={classes.statsIcon} 
                  style={{ backgroundColor: '#ff9800' }}
                >
                  <TrendingUpIcon />
                </Avatar>
                <Typography className={classes.statsNumber}>
                  {analyticsLoading ? '...' : (analyticsData?.analyticsData?.totalPlays || 0).toLocaleString()}
                </Typography>
                <Typography className={classes.statsLabel}>
                  Total Plays
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Recent Activity */}
        <Box display="flex" style={{ gap: "2rem" }} marginBottom="20px">
          <Box width="100%">
            <Card className={classes.activityCard}>
              <Typography className={classes.activityTitle}>
                Recent Activity
              </Typography>
              <List>
                {analyticsLoading ? (
                  <ListItem className={classes.activityItem}>
                    <ListItemText
                      primary="Loading recent activity..."
                      classes={{ primary: classes.activityText }}
                    />
                  </ListItem>
                ) : recentActivityItems.length === 0 ? (
                  <ListItem className={classes.activityItem}>
                    <ListItemText
                      primary="No recent activity available."
                      classes={{ primary: classes.activityText }}
                    />
                  </ListItem>
                ) : (
                  recentActivityItems.map((activity: any, index: number) => {
                    const { Icon, color } = getActivityIcon(activity?.type || '');
                    const title = activity?.title || activity?.description || 'Activity';
                    const subtitleParts = [
                      activity?.description && activity.description !== title ? activity.description : '',
                      formatActivityTime(activity?.time)
                    ].filter(Boolean);
                    return (
                      <Box key={`${activity?.type || 'activity'}-${index}`}>
                        {index > 0 && <Divider className={classes.divider} />}
                        <ListItem className={classes.activityItem}>
                          <ListItemAvatar>
                            <Avatar style={{ backgroundColor: color }}>
                              <Icon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={title}
                            secondary={subtitleParts.join(' • ')}
                            classes={{ primary: classes.activityText, secondary: classes.activityTime }}
                          />
                        </ListItem>
                      </Box>
                    );
                  })
                )}
              </List>
            </Card>
          </Box>
        </Box>

        <Box display="flex" style={{ gap: "2rem" }} marginBottom="20px">
          <Box width="100%" bgcolor="#192B3C" borderRadius="10px" >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h3 className={classes.chartHead}>
                Plays / Revenue Trends
              </h3>
              <FormControl variant="standard" sx={{ m: 1, width: 120 }} style={{ fontSize: '12px' }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={typeRevenue}
                  onChange={handleRevenueChange}
                  label="Age"
                >
                  <MenuItem value={"today"}>Today</MenuItem>
                  <MenuItem value={"week"}>Past 7 Days</MenuItem>
                  <MenuItem value={"month"}>Past Month</MenuItem>
                  <MenuItem value={"year"}>This Year</MenuItem>
                  <MenuItem value={"allTime"}>All Time</MenuItem>
                </Select>
              </FormControl>
            </div>
            {loading5 ? (
              <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#fff' }}>Loading trend data...</Typography>
              </Box>
            ) : error5 ? (
              <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                <Typography style={{ color: '#b0b0b0' }}>
                  {error5.message && (error5.message.includes('Unauthorized') || error5.message.includes('admin account'))
                    ? 'Sign in with an admin account to see revenue data.'
                    : `Error loading trend data. ${error5.message || 'Please check authentication.'}`}
                </Typography>
              </Box>
            ) : playsRevenueTrend.length === 0 ? (
              <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                <Typography style={{ color: '#b0b0b0' }}>No trend data available for this time period.</Typography>
              </Box>
            ) : (
              <ResponsiveContainer width="95%" aspect={3}>
                <LineChart data={playsRevenueTrend}>
                  <XAxis dataKey='label' />
                  <YAxis
                    yAxisId="plays"
                    orientation="left"
                    tick={{ fill: '#ff9800' }}
                    axisLine={{ stroke: '#ff9800' }}
                    tickLine={{ stroke: '#ff9800' }}
                  />
                  <YAxis
                    yAxisId="revenue"
                    orientation="right"
                    tickFormatter={(value: number) => `$${Number(value).toLocaleString()}`}
                    tick={{ fill: '#3D7670' }}
                    axisLine={{ stroke: '#3D7670' }}
                    tickLine={{ stroke: '#3D7670' }}
                  />
                  <Tooltip />
                  <Legend />
                  <Line yAxisId="plays" type="monotone" dataKey='Plays' stroke="#ff9800" strokeWidth="2px" activeDot={{ r: 4 }} name="Plays" />
                  <Line yAxisId="revenue" type="monotone" dataKey='TotalRevenue' stroke="#3D7670" strokeWidth="3px" activeDot={{ r: 5 }} name="Revenue ($)" />
                </LineChart>
              </ResponsiveContainer>
            )}
          </Box>
        </Box>


        <div style={{ display: "flex", gap: '1rem' }}>
          <Box display="flex" style={{ gap: "2rem", flexGrow: 1 }} marginBottom="20px">
            <Box width="100%" bgcolor="#192B3C" borderRadius="10px" >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h3 className={classes.chartHead}>
                  Total Streamer Signup
                </h3>
                <FormControl variant="standard" sx={{ m: 1, width: 120 }} style={{ fontSize: '12px' }}>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={typeuser}
                    onChange={handleChangeUser}
                    label="Age"
                  >
                    <MenuItem value={"today"}>Today</MenuItem>
                    <MenuItem value={"week"}>Past 7 Days</MenuItem>
                    <MenuItem value={"month"}>Past Month</MenuItem>
                    <MenuItem value={"year"}>This Year</MenuItem>
                    <MenuItem value={"allTime"}>All Time</MenuItem>
                  </Select>
                </FormControl>
              </div>
              {loading1 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#fff' }}>Loading streamer data...</Typography>
                </Box>
              ) : error1 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#ff9800' }}>
                    Error loading streamer data. {error1.message || 'Please check authentication or try a different date range.'}
                  </Typography>
                </Box>
              ) : streamer.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#b0b0b0' }}>No streamer signup data available for this time period.</Typography>
                </Box>
              ) : (
                <ResponsiveContainer width="95%" aspect={3}>
                  <LineChart data={streamer}>
                    <XAxis dataKey='label' />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey='UserSignup' stroke="#3D7670" strokeWidth="3px" activeDot={{ r: 5 }} />
                  </LineChart>
                </ResponsiveContainer>
              )}
            </Box>
          </Box>

          <Box display="flex" style={{ gap: "2rem", flexGrow: 1 }} marginBottom="20px" >
            <Box width="100%" bgcolor="#192B3C" borderRadius="10px">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h3 className={classes.chartHead}>
                  Total Artist Signup
                </h3>
                <FormControl variant="standard" sx={{ m: 1, width: 120 }} style={{ fontSize: '12px' }}>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={typeartist}
                    onChange={handleChangeArtist}
                    label="Age"
                  >
                    <MenuItem value={"today"}>Today</MenuItem>
                    <MenuItem value={"week"}>Past 7 Days</MenuItem>
                    <MenuItem value={"month"}>Past Month</MenuItem>
                    <MenuItem value={"year"}>This Year</MenuItem>
                    <MenuItem value={"allTime"}>All Time</MenuItem>
                  </Select>
                </FormControl>
              </div>
              {loading2 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#fff' }}>Loading artist data...</Typography>
                </Box>
              ) : error2 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#ff9800' }}>
                    Error loading artist data. {error2.message || 'Please check authentication or try a different date range.'}
                  </Typography>
                </Box>
              ) : artist.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={3}>
                  <Typography style={{ color: '#b0b0b0' }}>No artist signup data available for this time period.</Typography>
                </Box>
              ) : (
                <ResponsiveContainer width="95%" aspect={3}>
                  <LineChart data={artist}>
                    <XAxis dataKey='label' />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey='ArtistSignup' stroke="#3D7670" strokeWidth="3px" activeDot={{ r: 5 }} />
                  </LineChart>
                </ResponsiveContainer>
              )}
            </Box>
          </Box>
        </div>
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="space-between"
          style={{ gap: "1rem", marginTop: '50px' }}
        >
          <Box display="flex" style={{ gap: "3rem", flexWrap: 'wrap' }}>
            <div onClick={() => setTabs('album')}>
              <h2 className={tabs === "album" ? classes.underline : " "} style={{ fontSize: "22px", cursor: "pointer" }}>
                Top Album
              </h2>
            </div>
            <div onClick={() => setTabs('song')}>
              <h2 className={tabs === "song" ? classes.underline : " "} style={{ fontSize: "22px", cursor: "pointer" }}>
                Top Songs
              </h2>
            </div>
            <div onClick={() => setTabs('artist')}>
              <h2 className={tabs === "artist" ? classes.underline : " "} style={{ fontSize: "22px", cursor: "pointer" }}>
                Top Artist
              </h2>
            </div>
          </Box>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <Typography style={{ margin: '0 8px 0 0', fontSize: '14px', color: '#3D7670' }}>
              Period
            </Typography>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ fontSize: '12px' }}>
              <Select
                labelId="dashboard-top-section-period"
                id="dashboard-top-section-period"
                value={type}
                onChange={handleChange}
                label="Period"
              >
                <MenuItem value={"today"}>Today</MenuItem>
                <MenuItem value={"week"}>Past 7 Days</MenuItem>
                <MenuItem value={"month"}>Past Month</MenuItem>
                <MenuItem value={"year"}>This Year</MenuItem>
                <MenuItem value={"allTime"}>All Time</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box>
          {comp}
          {/* {tabs === 'streaming' ? <TopAlbums type={type} /> : <TopArtist type={type} />} */}
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
